import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import FavoriteOpportunitiesPage from '@/components/opportunities/favorites_page.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(FavoriteOpportunitiesPage, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
